/*
 * Shrine PredictiveSearch.open() calls getResultsMaxHeight(), which does:
 *   document.querySelector('.section-header').getBoundingClientRect()
 * without a null check. This store uses wls-header (Dawn header is disabled),
 * so that selector used to be null and the dropdown never opened.
 */
(() => {
  const patch = () => {
    const Ctor = customElements.get('predictive-search');
    if (!Ctor || Ctor.prototype.__wlsMaxHeightPatched) return;

    Ctor.prototype.getResultsMaxHeight = function getResultsMaxHeight() {
      const header =
        document.querySelector('.section-header') ||
        document.querySelector('.wls-header') ||
        document.querySelector('header');
      const bottom = header ? header.getBoundingClientRect().bottom : 0;
      this.resultsMaxHeight = window.innerHeight - bottom;
      return this.resultsMaxHeight;
    };

    Ctor.prototype.__wlsMaxHeightPatched = true;
  };

  if (customElements.get('predictive-search')) {
    patch();
  } else {
    customElements.whenDefined('predictive-search').then(patch);
  }
})();
